import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { useParams } from 'react-router-dom';
import { useUserRolePermissions } from 'hooks';
import { useViewLocationDetailsByTrailerQuery } from '../trailerStatusEndpoints';
import LocationCard, { LocationCardSkeleton } from '../components/LocationCard';
import AddLocationsWizard from './add-locations-to-trailer-wizard/AddLocationsWizard';
import AddItemButton from '../../../components/AddItemButton';

const LocationCardList = ({ locationFilterValue, trailerData }) => {
  const { viewById } = useParams();
  const { isDispatchingManage } = useUserRolePermissions();
  const params = { trailerId: viewById };
  const {
    data = [],
    isLoading,
    isSuccess,
  } = useViewLocationDetailsByTrailerQuery({ params }, { skip: R.isNil(viewById) });

  const locationFilter = ({ locationId, name }) =>
    `${locationId} ${name}`.toUpperCase().includes(locationFilterValue.toUpperCase());
  const filteredLocations = data.filter(locationFilter);

  const [addLocationOpened, openAddLocation] = useState(false);
  const handleAddLocationOpen = R.compose(openAddLocation, R.T);
  const handleAddLocationClose = R.compose(openAddLocation, R.F);

  if (isLoading)
    return (
      <>
        <LocationCardSkeleton />
        <LocationCardSkeleton />
        <LocationCardSkeleton />
      </>
    );

  const isActive = trailerData?.status !== 'DEACTIVATED';

  return (
    <>
      {isSuccess && isDispatchingManage && isActive && (
        <AddItemButton itemName="Location" onAdd={handleAddLocationOpen} />
      )}
      {filteredLocations.map(({ locationId: locId, name }) => (
        <LocationCard key={locId} locationId={locId} title={name} />
      ))}
      {addLocationOpened && (
        <AddLocationsWizard onClose={handleAddLocationClose} openDrawer={addLocationOpened} />
      )}
    </>
  );
};

LocationCardList.propTypes = {
  locationFilterValue: PropTypes.string.isRequired,
  trailerData: PropTypes.shape({
    status: PropTypes.string,
  }).isRequired,
};

export default LocationCardList;
